import { GET_EVENTS } from "constants/events";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_EVENTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
